import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-playlist-placeholder';
export var ID = 'icon-playlist-placeholder';
/* eslint-disable max-len */

export var SVGPlaylistPlaceholder = function SVGPlaylistPlaceholder() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 135 135"
  }, React.createElement("defs", null, React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "70.7106781%",
    id: "pp-gradient-1"
  }, React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#FBF8F8",
    offset: "100%"
  })), React.createElement("rect", {
    id: "pp-path-1",
    x: "0",
    y: "0",
    width: "135",
    height: "135",
    rx: "3.375"
  }), React.createElement("mask", {
    id: "pp-mask-1",
    fill: "white"
  }, React.createElement("use", {
    xlinkHref: "#pp-path-1"
  }))), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-15.000000, -15.000000)"
  }, React.createElement("g", {
    transform: "translate(15.000000, 15.000000)"
  }, React.createElement("use", {
    fill: "url(#pp-gradient-1)",
    xlinkHref: "#pp-path-1"
  }), React.createElement("path", {
    d: "M149.863503,123.363 C149.863503,154.590698 124.559226,179.901 93.3223221,179.901 C62.1108527,179.910539 36.7875,154.593878 36.7875,123.363 C36.7875,92.1384817 62.1108527,66.825 93.3191428,66.825 C124.559226,66.825 149.863503,92.1384817 149.863503,123.363",
    fill: "#FFD5BB",
    mask: "url(#pp-mask-1)"
  }), React.createElement("path", {
    d: "M99.4536692,28.7248836 C93.5763814,27.8321067 88.8058556,27.8505779 84.7159248,27.2902835 C79.6559871,26.9116229 70.0863123,25.6247927 67.3194073,21.2625 C67.3194073,21.2625 67.2558003,21.6503962 67.2112754,22.3676963 C67.1031435,23.9716162 67.0936024,27.1825345 68.0699701,31.3170152 C68.9986324,34.8111593 70.3407403,38.382267 72.2457703,41.7717407 C72.8563976,42.843073 73.5528944,43.9267195 74.3193589,45.0257587 C79.0421794,51.6600147 86.5350853,56.3948109 97.7998869,58.8545652 C112.569435,62.0716407 126.58524,64.3867036 137.462038,77.79375 C137.487481,77.7414148 137.500203,77.6736869 137.528826,77.6151946 C139.529266,70.3436806 131.950491,33.625921 99.4536692,28.7248836",
    fill: "#CFDEB6",
    mask: "url(#pp-mask-1)"
  })))));
};
/* eslint-disable max-len */

var PlaylistPlaceholder = function PlaylistPlaceholder(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGPlaylistPlaceholder
  });
};

PlaylistPlaceholder.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default PlaylistPlaceholder;